import * as React from "react";
import { Label } from "../../../../components/ui/label";
import { TextInput } from "../TextInput";
import { DropdownInput } from "../DropdownInput";
import axios from "axios";

const validate = async (v) => {
  const res = await axios.get(`/api/document/validate/${encodeURIComponent(v)}`);
  return res;
}

const Body = ({
  register,
  control,
  states,
  formKey,
  stepId,
  sameAs,
  disableFields,
  version
}) => (
  <>
    <div className="grid gap-4 md:grid-cols-2">
      <TextInput
        register={register}
        label="Address"
        id={`${formKey.split('.').join('-')}-mail-address1`}
        stepName={`${formKey}.address1`}
        stepId={stepId}
        disabled={disableFields}
        extraInfo={version === "v2" ? undefined : "Mailing address must match FMCSA/SAFER records for filings to be processed"}
      />
      <TextInput
        register={register}
        label="Address Line 2"
        id={`${formKey.split('.').join('-')}-mail-address2`}
        stepName={`${formKey}.address2`}
        stepId={stepId}
        disabled={disableFields}
      />
    </div>

    <div className="grid gap-4 md:grid-cols-3">
      <TextInput
        register={register}
        label={"City"}
        id={`${formKey.split('.').join('-')}-mail-city`}
        stepName={`${formKey}.city`}
        stepId={stepId}
        disabled={disableFields}
      />
      <DropdownInput
        validate={version === "v2" ? undefined : validate}
        control={control}
        label={"State"}
        dropdownLabel={"States"}
        stepName={`${formKey}.state`}
        stepId={stepId}
        disabled={disableFields}
        itemList={states}
      />
      <TextInput
        register={register}
        label={"ZIP Code"}
        id={`${formKey.split('.').join('-')}-mail-zip`}
        stepName={`${formKey}.zip`}
        stepId={stepId}
        disabled={disableFields}
      />
    </div>

    {sameAs && (<div className="flex items-center gap-2">
      <input
        id={sameAs?.id}
        type="checkbox"
        className="h-4 w-4"
        disabled={disableFields}
        {...register(sameAs?.formKey)}
      />
      <Label htmlFor={sameAs?.id} className="cursor-pointer">
        {sameAs?.label}
      </Label>
    </div>)}
  </>
)
export function Address({
  register,
  control,
  states,
  title,
  formKey,
  stepId,
  sameAs,
  disableFields,
  version
}) {
  return (
    <>
      {
        version === "v2" ? <Body
          register={register}
          control={control}
          states={states}
          formKey={formKey}
          stepId={stepId}
          sameAs={sameAs}
          disableFields={disableFields}
          version={version}
        /> : <div className="rounded-lg border p-4 space-y-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <Body
            register={register}
            control={control}
            states={states}
            formKey={formKey}
            stepId={stepId}
            sameAs={sameAs}
            disableFields={disableFields}
            version={version}
          />
        </div>
      }
    </>
  );
}
